// biome-ignore-all lint/suspicious/noConsole: we intentionally use console.error for logging
import { isProd } from '../utils';
// API abstraction of https://developer.zendesk.com/api-reference/widget-messaging/web/core/
import { CONVERSATION_FIELD_MAP } from '../constants';
export function open() {
    try {
        window.zE?.('messenger', 'open');
    }
    catch (err) {
        console.error('Zendesk API - Error opening messenger', err);
    }
}
export function close() {
    try {
        window.zE?.('messenger', 'close');
    }
    catch (err) {
        console.error('Zendesk API - Error closing messenger', err);
    }
}
export function show() {
    try {
        window.zE?.('messenger', 'show');
    }
    catch (err) {
        console.error('Zendesk API - Error showing messenger', err);
    }
}
export function hide() {
    try {
        window.zE?.('messenger', 'hide');
    }
    catch (err) {
        console.error('Zendesk API - Error hiding messenger', err);
    }
}
export function setZIndex(value) {
    try {
        window.zE?.('messenger:set', 'zIndex', value);
    }
    catch (err) {
        console.error('Zendesk API - Error setting zIndex', err);
    }
}
export function setConversationFields(fieldId, value) {
    try {
        window.zE?.('messenger:set', 'conversationFields', [
            { id: fieldId, value },
        ]);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Conversation Fields', err);
    }
}
export function setConversationTags(tags) {
    try {
        window.zE?.('messenger:set', 'conversationTags', tags);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Conversation Tags', err);
    }
}
/**
 * Custom abstractions methods
 */
export function setErrorCode(errorCode) {
    try {
        if (!isProd()) {
            console.debug('Zendesk API - Skipping setErrorCode on non prod env', errorCode);
            return;
        }
        setConversationFields(CONVERSATION_FIELD_MAP.ERROR_CODE, errorCode);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Error Code', err);
    }
}
export function setPropertyAddress(propertyAddress) {
    try {
        if (!isProd()) {
            console.debug('Zendesk API - Skipping setPropertyAddress on non prod env', propertyAddress);
            return;
        }
        setConversationFields(CONVERSATION_FIELD_MAP.PROPERTY_ADDRESS, propertyAddress);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Property Address', err);
    }
}
export function setInteractionId(interactionId) {
    try {
        if (!isProd()) {
            console.debug('Zendesk API - Skipping setInteractionId on non prod env', interactionId);
            return;
        }
        setConversationFields(CONVERSATION_FIELD_MAP.INTERACTION_ID, interactionId);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Interaction ID', err);
    }
}
export function setTransactionId(transactionId) {
    try {
        if (!isProd()) {
            console.debug('Zendesk API - Skipping setTransactionId on non prod env', transactionId);
            return;
        }
        setConversationFields(CONVERSATION_FIELD_MAP.TRANSACTION_ID, transactionId);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Interaction ID', err);
    }
}
export function setPageUrl(pageUrl) {
    try {
        if (!isProd()) {
            console.debug('Zendesk API - Skipping setPageUrl on non prod env', pageUrl);
            return;
        }
        setConversationFields(CONVERSATION_FIELD_MAP.PAGE_URL, pageUrl);
    }
    catch (err) {
        console.error('Zendesk API - Error setting Page URL', err);
    }
}
/**
 * Event Handlers
 */
export function onOpen(callback) {
    // TODO: Guard against being called multiple times and duplicating listeners
    window.zE?.('messenger:on', 'open', callback);
}
export function onClose(callback) {
    // TODO: Guard against being called multiple times and duplicating listeners
    window.zE?.('messenger:on', 'close', callback);
}
export function onUnreadMessages(callback) {
    // TODO: Guard against being called multiple times and duplicating listeners
    window.zE?.('messenger:on', 'unreadMessages', callback);
}
